export default __webpack_public_path__ + "static/media/javascript.26cd97a1.png";